<template class="full-height">
  <div class="app-position-container" style="position: relative; height: 100%; padding: 10px">
    <div style="padding: 20px; padding-bottom: 0">
      <el-form :inline="true">
        <!-- <el-form-item label="代碼查詢">
          <el-input v-model="listQuery.qry" placeholder="輸入景點名稱" />
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="getList">查詢</el-button>
        </el-form-item>

        <el-form-item>
          <el-button type="success" @click="addData">新增</el-button>
        </el-form-item> -->
        <el-form-item>
          <!-- <el-alert show-icon closable="false" type="info"
            >經緯度資料系統保留7天內資紀錄</el-alert
          > -->
        </el-form-item>
        <el-form-item>
          <el-button
            style="cursor: pointer"
            :loading="listLoading"
            type="success"
            icon="el-icon-refresh-left"
            circle
            @click="refresh()"
          ></el-button>
        </el-form-item>
      </el-form>
    </div>

    <div style="position: relative; height: 80%">
      <el-table
        v-loading="listLoading"
        size="mini"
        :data="list"
        border
        fit
        highlight-current-row
        height="100%"
      >
        <el-table-column align="center" label="項次" width="60">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="日期" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.recordDate }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="團ID" width="60">
          <template slot-scope="scope">
            <span>{{ scope.row.travelID }}</span>
          </template>
        </el-table-column>

        <el-table-column align="left" label="團名" width="300">
          <template slot-scope="scope">
            <span>{{ scope.row.travelName }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="userAccount" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.userAccount }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="userName" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.userName }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" :label="funcName + '座標緯度'" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.lat }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" :label="funcName + '座標經度'" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.lng }}</span>
          </template>
        </el-table-column>

        <!-- <el-table-column align="center" label="編輯" width="120">
          <template slot-scope="scope">
            <el-button type="primary" @click="editData(scope.row)"
              >查看</el-button
            >
          </template>
        </el-table-column> -->
      </el-table>
    </div>
    <pagination
      v-show="total > 0"
      style="padding-top: 0"
      layout="prev, pager, next"
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      @pagination="getList"
    />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination' // Secondary package based on el-pagination
import { MessageBox, Message } from 'element-ui'

import { getViewPoints, saveViewPoint } from '@/api/travel'

import { getAppPosition } from '@/api/system'

var defaultForm = {
  viewPointName: '',
  lat: 0,
  lng: 0,
}

export default {
  name: 'AppPosition',
  components: {
    Pagination,
  },
  data() {
    return {
      funcName: '景點',
      dialogTopMargin: '5%',
      formLabelWidth: '120px',
      form: {},
      dialogLoading: false,
      dialogVisible: false,
      listLoading: false,
      listQuery: {
        qry: '',
        date: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '-travelID',
      },
      total: 0,
      list: [],
    }
  },
  async created() {
    this.form = defaultForm
    await this.getList()
  },
  methods: {
    async refresh() {
      this.listQuery = {
        qry: '',
        date: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '-id',
      }
      await this.getList()
    },
    addData() {
      this.dialogVisible = true
    },
    editData(row) {
      this.form = row
      this.dialogVisible = true
    },
    async saveData() {
      let vm = this
      if (!confirm(`確定要儲存【${vm.funcName}}】資料?`)) {
        return
      }

      this.$refs['form'].validate(async valid => {
        if (valid) {
          vm.dialogLoading = true
          let resp = await saveViewPoint(this.form)
          await vm.getList()
          this.dialogVisible = false
          vm.dialogLoading = false
          Message({
            message: '資料處理完成',
            type: 'success',
            duration: 5 * 1000,
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    async getList() {
      this.listLoading = true
      let resp = await getAppPosition(this.listQuery)
      this.list = resp.data.data
      // console.log(this.list);
      this.total = resp.data.total
      this.listLoading = false
    },
  },
}
</script>

<style>
.full-height {
  position: relative;
  height: 100%;
}

.el-dialog__body {
  padding-top: 0px;
}
</style>
